import cn from 'classnames';
// Ui
import MillionsIcon, { IconNames } from 'ui3/MillionsIcon/MillionsIcon';
import Loader, { LoaderColor } from 'ui3/Loader/Loader';
// Styles
import styles from './Button.module.scss';

export type ButtonVariant = 'primary' | 'secondary' | 'success' | 'error';
export type ButtonSize = 'large' | 'medium' | 'small' | 'fat';
export type ButtonIcon = IconNames;

export type BasicButtonProps = {
  loading?: boolean;
  size?: ButtonSize;
  subVariant?: 'outlined' | 'text';
  variant?: ButtonVariant;
  block?: boolean;
  icon?: ButtonIcon;
  iconPosition?: 'left' | 'right';
  buttonContentClassName?: string;
  iconClassName?: string;
  loaderColor?: LoaderColor;
};

export type ButtonProps = React.ComponentPropsWithoutRef<'button'> &
  BasicButtonProps;

const Button = ({
  children,
  variant = 'primary',
  subVariant,
  size = 'large',
  loading,
  className,
  disabled,
  icon,
  iconClassName,
  block,
  type = 'button',
  iconPosition = 'left',
  buttonContentClassName,
  loaderColor = 'current',
  ...rest
}: ButtonProps) => {
  return (
    <button
      className={cn(
        styles.button,
        styles[variant],
        {
          [styles.outline]: subVariant === 'outlined',
          [styles.text]: subVariant === 'text',
          [styles.block]: block,
        },
        styles[size],
        className
      )}
      disabled={disabled || loading}
      type={type}
      {...rest}
    >
      <span className={cn(styles.buttonContent, buttonContentClassName)}>
        {loading && (
          <Loader loading={loading} size="small" related color={loaderColor} />
        )}
        {icon && iconPosition === 'left' && (
          <MillionsIcon name={icon} className={iconClassName} />
        )}
        {children && <>{children}</>}
        {icon && iconPosition === 'right' && (
          <MillionsIcon name={icon} className={iconClassName} />
        )}
      </span>
    </button>
  );
};

export default Button;
